import { render, staticRenderFns } from "./ModalBase64.vue?vue&type=template&id=24252b16&scoped=true&"
import script from "./ModalBase64.vue?vue&type=script&lang=js&"
export * from "./ModalBase64.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24252b16",
  null
  
)

export default component.exports